import { useEffect } from "react";
import { Form, Select } from "antd";

const { Option } = Select;

const PreconditionForm = ({ form, stepData, activeStepIndex, stepsCount }) => {
  useEffect(() => {
    if (stepData) {
      form.setFieldsValue({
        precondition: stepData.precondition || undefined,
      });
    } else {
      form.resetFields();
    }
  }, [stepData, form, activeStepIndex]);

  // Create an array of indices from 0 to activeStepIndex-1
  const preconditionOptions = Array.from(
    { length: Math.max(0, activeStepIndex) },
    (_, index) => ({
      label: `Step ${index + 1}`,
      value: `step${index + 1}`,
    })
  );

  return (
    <Form form={form} layout="vertical" name="preconditionForm">
      <Form.Item
        name="precondition"
        label="Precondition"
        rules={[{ required: true, message: "Please select a precondition!" }]}
      >
        <Select
          placeholder="Select Precondition"
          disabled={preconditionOptions.length === 0}
        >
          {preconditionOptions.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default PreconditionForm;
